<template>
  <div
    :class="parentClasses"
    :style="parentStyles"
    :data-aos="aos('container', 'type')"
    :data-aos-duration="aos('container', 'duration')"
    :data-aos-delay="aos('container', 'delay')"
  >
    <div class="row">
      <div class="col-12">
        <slot name="slot1"></slot>
      </div>
    </div>
    <video
      class="bg-video"
      muted
      playsinline
      :autoplay="video.autoplay"
      :loop="video.loop"
      :poster="posterUrl"
      v-if="objC.backgroundVid"
    >
      <source :src="bgUrl" type="video/mp4" />
    </video>
  </div>
</template>

<script>
	export default {
		name: "GroupContainer",
		data: function () {
			return {
				poster: null,
				windowWidth: null,
				bgUrl: null,
				video: {
					autoplay: true,
					loop: true,
				}
			}
		},
		props: {
			obj: Object
		// {
		//   type: 'Hero',
		//   variant: '',
		//   classes: '',
		//   transitions: {
		//     // Fill out if we are using aos.
		//     // Can do any other visible content item, like subtitle or graphic.
		//     // Content: container
		//     // Attributes: type, duration, and delay
		//     aos: {
		//       container: {
		//         type: 'fade-left',
		//         duration: 2000
		//       }
		//     },
		//     gsap: {
		//       components: [],
		//       script: ''
		//     }
		//   },
		//   presentation: {
		//     fullWidth: Boolean,
		//     backgroundAction: 'scroll' // String - 'scroll' or 'fixed',
		//     video: { // Optional
    //       autoplay: true,
    //       loop: true,
    //     }
		//   },
		//   content: {
		//     backgroundColor: '#cccccc', // String - color name, hex, or rgb,
		//     backgroundImg: '', // String - url to asset,
		//     backgroundImgMob: '', // String - url to asset for Tablet,
		//     backgroundImgTab: '', // String - url to asset for Mobile,
		//     backgroundVid: '' // String - url to asset
		//     backgroundVidTab: '' // String - url to asset
		//     backgroundVidMob:'' // String - url to asset
		//   }
		// }
	},
	computed: {
		objP () {
			return this.obj.presentation
		},
		objC () {
			return this.obj.content
		},
		posterUrl: function () {
			const imgUrl = this.objC.backgroundImg
			const vidUrl = this.objC.backgroundVid
			return (!vidUrl) ? false: (!imgUrl) ? false : (imgUrl.includes('http')) ? imgUrl : require(`@/${imgUrl}`)
		},
		parentClasses: function () {
			let classStr = 'ime-group-parent'
			if (!this.objP.fullWidth) {
				classStr+=' container'
			}
			if (this.objP.fullWidth) {
				classStr+=' container-fluid'
			}
			if (this.obj.variant) {
				classStr+=' '+this.obj.variant
			}
			if (this.obj.classes) {
				classStr+=' '+this.obj.classes
			}
			return classStr
		},
		parentStyles: function () {
			const oC = this.objC
			let styleStr = ''
			if (oC.backgroundColor) {
				styleStr += 'background-color: ' + oC.backgroundColor + ';'
			}
			if (this.objP.backgroundAction) {
				styleStr += 'background-attachment: ' + this.objP.backgroundAction + ';'
			}
			if (oC.backgroundImg && !oC.backgroundVid) {
				styleStr += 'background-image: url("' + this.bgUrl + '");background-position: top center;background-repeat: no-repeat;background-size: cover;height: 100%;width: 100%;'
			}
			return styleStr
		}
	},
	watch: {
		windowWidth() {
			let url
			const oC = this.objC
			const str = (oC.backgroundVid) ? 'backgroundVid' : 'backgroundImg'
			const desk = oC[str]
			const tab = oC[str+'Tab']
			const mob = oC[str+'Mob']
			if (this.windowWidth >= 992) {
				url = desk ? desk : false 
			} else if (this.windowWidth >= 767 && this.windowWidth < 992) {
				url = tab ? tab : desk ? desk : false
			} else {
				url = mob ? mob : tab ? tab : desk ? desk : false
			}
			this.bgUrl = (!url) ? false : (url.includes('http')) ? url : require(`@/${url}`)
		}
	},
	methods: {
		getWindowWidth() {
			const contElem = document.querySelector('.container');
			const win = parseInt(window.getComputedStyle(contElem).maxWidth)
			this.windowWidth = (win) ? win : 0
		},
		aos(content, attr) {
			// safe traversal, we don't have to define every attribute in the store.
			// Same thing as dog?.action?.bark in other languages.
			return ((this.obj.transitions.aos || {})[content] || {})[attr] || null
		}
	},
	mounted() {
		this.$nextTick(function() {
			window.addEventListener('resize', this.getWindowWidth);
			this.getWindowWidth();
			if(this.obj.presentation.video){
				this.video.autoplay = this.obj.presentation.video.autoplay ? true : false;
				this.video.loop = this.obj.presentation.video.loop ? true : false;
			}

			if (this.obj.transitions.gsap.script) {
				this.obj.transitions.gsap.script()
			}
		})
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.getWindowWidth);
	}
	
}
</script>

<style lang="scss" scoped>
.ime-group-parent {
  overflow: hidden;
  position: relative;
  z-index: 1;
  .bg-video {
    bottom: auto;
    height: auto;
    left: 50%;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    right: auto;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
  }
  > .row {
    > .col-12 {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>